import Cookies from 'js-cookie'
import { queryKeys } from '@/lib/queryKeys'

export type SavedSearchQuery = {
  name: string
  query: string
  createdAt: number
}

export type SavedSearchConfig = {
  cookieKey: string
  cookieOptions: { secure: boolean; expires: number; path: string }
  queryKey: () => readonly string[]
}

export const opportunitySavedSearch: SavedSearchConfig = {
  cookieKey: 'opportunity-saved-queries',
  cookieOptions: { secure: window.location.protocol === 'https:', expires: 30, path: '/' },
  queryKey: queryKeys.opportunities.savedQueries,
}

export const inquirySavedSearch: SavedSearchConfig = {
  cookieKey: 'inquiry-saved-queries',
  cookieOptions: { secure: window.location.protocol === 'https:', expires: 30, path: '/' },
  queryKey: queryKeys.inquiries.savedQueries,
}

/** Cookie から保存済みの検索条件を読み取る。Cookie がない・配列でない・壊れている場合は空の一覧を返す */
export function readSavedQueries(config: SavedSearchConfig): SavedSearchQuery[] {
  try {
    const parsed: unknown = JSON.parse(Cookies.get(config.cookieKey) || '[]')
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}
